/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OAuth2TokenRequest = {
  /**
   * OAuth2 grant type
   */
  grant_type: OAuth2TokenRequest.grant_type;
  /**
   * User email (required for password grant)
   */
  username?: string | null;
  /**
   * User password (required for password grant)
   */
  password?: string | null;
  /**
   * Refresh token (required for refresh_token grant)
   */
  refresh_token?: string | null;
  /**
   * Authorization code (required for authorization_code grant)
   */
  code?: string | null;
  /**
   * Redirect URI (required for authorization_code grant)
   */
  redirect_uri?: string | null;
  /**
   * OAuth2 scope (space-separated list)
   */
  scope?: string | null;
  /**
   * OAuth2 client ID
   */
  client_id?: string | null;
  /**
   * OAuth2 client secret (if using client authentication)
   */
  client_secret?: string | null;
};
export namespace OAuth2TokenRequest {
  /**
   * OAuth2 grant type
   */
  export enum grant_type {
    PASSWORD = 'password',
    REFRESH_TOKEN = 'refresh_token',
    AUTHORIZATION_CODE = 'authorization_code',
    CLIENT_CREDENTIALS = 'client_credentials',
  }
}
